export enum GRANT_TYPES {
  AUTH_CODE = 'authorization_code',
  REFRESH_TOKEN = 'refresh_token',
}
